import React, { Component } from 'react';

import * as apiConstant from '../../api/apiConstant';
import store from '../../store/configureStore';
import {lang} from '../../config/lang';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {addNotification} from "../../actions/notificationAction";
import specialApi from '../../api/specialApi';

/****************************************
    Component for content of a special page
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/
class SpecialBlock extends Component {
    
    constructor(props) {
        super(props);

        var date = new Date(Date.parse(this.props.date));
        var d = date.getDate();
        var m = date.getMonth() + 1;

        date = date.getFullYear() + "." + m + "." + d + ".";
        
        this.state = {
            date: date
        }

        this.getTitleByLang = this.getTitleByLang.bind(this);
        this.checkMedia = this.checkMedia.bind(this);
        this.getMedia = this.getMedia.bind(this);
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        window.playVideo();
        window.articleGallery();
        window.checkSize();
    }
    
    componentWillUnmount() {
        
    }

    componentWillUpdate() {
        
    }


    componentDidUpdate() {
        window.playVideo();
    }
    
    componentWillReceiveProps() {        
        // this.getTitleByLang();
    }

    getTitleByLang() {
        specialApi.getTitleByLang(this.props.id).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    title: (json.data.title === null ? "" : json.data.title)
                });
                // resolve();
            } else {
                if (json.status === 620) {
                    store.dispatch(addNotification(`${lang('access_deny')}`, 'error'));
                } else {
                    store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
                }
                // resolve();
            }            
        })
    }

    checkMedia(item) {
        return item.format === 1;
    }

    getMedia() {
        let media = [];
        media = this.props.images.filter(this.checkMedia);

        if(media.length !== 0){
            return media[0].name;
        }
        else
            return false;
    }

    render() {
        return (
            <div className="article clearfix">
                <div className="row">
                    <div className="col-md-10">
                        <Link to={`/special/${this.props.id}`} dangerouslySetInnerHTML={{__html: this.props.pKey + '. ' + (this.props.title === null ? "" : this.props.title)}}></Link>
                        <div data-lightbox="gallery"> 
                        {
                            this.props.images.map((image, key) => (
                                image.format === 0 ? 
                                    <Link 
                                        key={key}  
                                        to={ apiConstant.tablet(this.props.business, this.props.id, image.name) } 
                                        data-lightbox="gallery-item"> 
                                        &nbsp;&nbsp;[<i className="icon icon-camera"></i>] 
                                    </Link>
                                    : ''
                                )
                            )
                        }
                        </div>
                        {
                            (this.getMedia() !== false) &&
                            <a href={apiConstant.desktop(this.props.business, this.props.id, this.getMedia())}
                               className="play-video">
                               [<i className="icon icon-video-camera"></i>]
                            </a>
                        }
                        
                    </div>
                    <div className="col-md-2">
                        <Link to={`/special/${this.props.id}`} className="float-right">{this.state.date}</Link>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(SpecialBlock);
